// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"6d34501906de30f7","6008":"7a0582e39e9752d7","7570":"cda1432c8ff19ced"}[chunkId] + ".css";
};